import React from 'react';
// template base components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
// template modules
import CredentialCardSet from '@nmx/template/dist/componentLibrary/modules/CredentialCardSet';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// icons
import CaratRight from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/CaratRight';
// styles
import { LinkStyled } from './styles';

export default () => (
  <SectionContainer
    id='financial-planning-credential-callout-grouping'
    backgroundVariant='lightB'
    themeType='lightTheme'
    moduleName='credentials-module'
    moduleVariation='A'>
    <Row align='center'>
      <Col
        align='center'
        medium={8}>
        <Typography
          align='center'
          component='h2'
          nextElement='graphic'>
          Financial strength<sup>1</sup>
        </Typography>
      </Col>
    </Row>
    <CredentialCardSet
      accentColorVariant='gold'
      accentOrientation='vertical'
      backgroundVariant='lightB'
      credentials={[
        {
          credential: 'amBestCompany',
          sup1: <></>,
          additionalDescription: (
            <LinkStyled
              id='am-best-report-pdf-link'
              variant='buttonLinkTertiary'
              linkUrl='/assets/pdf/financial-reports/credit-agency-reports/am-best-report.pdf'
              isInternalPdf
              endAdornment={CaratRight}
              endAdornmentStylesReset>
              Ratings Analysis Report
            </LinkStyled>
          ),
        },
        {
          credential: 'fitchRatings',
          sup1: <></>,
          additionalDescription: (
            <LinkStyled
              id='fitch-report-pdf-link'
              variant='buttonLinkTertiary'
              linkUrl='/assets/pdf/financial-reports/credit-agency-reports/fitch-report.pdf'
              isInternalPdf
              endAdornment={CaratRight}
              endAdornmentStylesReset>
              Ratings Analysis Report
            </LinkStyled>
          ),
        },
        {
          credential: 'moodysInvestorsService',
          sup1: <>2</>,
          additionalDescription: (
            <LinkStyled
              id='moodys-report-pdf-link'
              variant='buttonLinkTertiary'
              linkUrl='/assets/pdf/financial-reports/credit-agency-reports/moodys-report.pdf'
              isInternalPdf
              endAdornment={CaratRight}
              endAdornmentStylesReset>
              Ratings Analysis Report
            </LinkStyled>
          ),
        },
        {
          credential: 'sAndPGlobalRatings',
          sup1: <>2</>,
          additionalDescription: (
            <LinkStyled
              id='sp-report-pdf-link'
              variant='buttonLinkTertiary'
              linkUrl='/assets/pdf/financial-reports/credit-agency-reports/sp-report.pdf'
              isInternalPdf
              endAdornment={CaratRight}
              endAdornmentStylesReset>
              Ratings Analysis Report
            </LinkStyled>
          ),
        },
      ]}
      hasAccent
      themeType='lightTheme'
    />
  </SectionContainer>
);
